import React from "react";
import {
  Grid,
  TableBody,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const SetuDetails = ({data}) => {
  return (
    <Card>
          
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={6} >
          Setu Details
          </Grid>
         
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Setu Order Id</TableBodyCell>
                <TableBodyCell className="common_table_content">{data['setu_order_id']}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Mobile No.</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["mobile_number"]}</TableBodyCell>
              </TableBody>
              {/* <TableBody>
                <TableBodyCell>Status</TableBodyCell>
                <TableBodyCell><BootstrapBadge backgroundColor="#0ABB87" text={data['status']} /></TableBodyCell>
              </TableBody> */}
             
            </table>
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <table className="w-full">
              {/* <TableBody>
                <TableBodyCell>Error Code</TableBodyCell>
                <TableBodyCell>{data['error_code']}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell>Error Description</TableBodyCell>
                <TableBodyCell>{data['error_description']}</TableBodyCell>
              </TableBody> */}
              <TableBody>
                <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                <TableBodyCell className="common_table_content">{readableFormatDate(data['created_at']) }</TableBodyCell>
              </TableBody>
             
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
      </Card>
          
  );
};
